/*
 * @Description: 跟进管理接口模块
 * @Author: mdb
 * @Date: 2022-07-19 10:24:19
 * @LastEditTime: 2022-07-20 15:44:59
 * @LastEditors: mdb
 */
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import {
  LbuVisitorProgramParams,
  LbuVisitorProgramListResult,
  LbuVisitorProgramEditParams
} from '@/typings/api/followUpManage'

/**
 * ************************************** 访客计划 **************************************
 */
//  获取访客计划列表数据
export function visitorProgramList(data?: LbuVisitorProgramParams) {
  return request.post<LbuVisitorProgramListResult, LbuVisitorProgramListResult>('/lbu/api/visitPlan/page', data)
}
// 新增访客计划
export function visitorProgramCreateOrUpdate(data: LbuVisitorProgramEditParams) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/visitPlan/createOrUpdate', data)
}
// 取消访客计划
export function visitorProgramCancel(id: string) {
  return request.put<AxiosResult, AxiosResult>(`/lbu/api/visitPlan/cancel/${id}`)
}
// 删除访客计划
export function visitorProgramDelete(id: string) {
  return request.delete<AxiosResult, AxiosResult>(`/lbu/api/visitPlan/${id}`)
}
// 访客计划详情
export function visitorProgramDetail(id: string) {
  return request.get<AxiosResult, AxiosResult>(`/lbu/api/visitPlan/${id}`)
}
/**
 *************************************** 跟进记录列表**************************************
 */
export function lbuFollowRecordsList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/followRecords/page', data)
}
/**
 * 跟进记录详情
 */
export function followRecordsDetail(id: any) {
  return request.get<AxiosResult, AxiosResult>(`/lbu/api/followRecords/${id}`)
}
/**
 * 跟进记录新增/编辑
 */
export function followRecordsAddOrUpdate(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/followRecords/createOrUpdate', data)
}
/**
 * 跟进记录删除
 */
export function followRecordsDelete(id: any) {
  return request.delete<AxiosResult, AxiosResult>(`/lbu/api/followRecords/${id}`)
}
/**
 * 获取跟进相关信息
 */
export function followRecordsAddByMess(params: any) {
  return request.get<AxiosResult, AxiosResult>('/lbu/api/followRecords/getFollowInfo', { params })
}
/**
 * 添加评论
 */
export function followRecordsAddComment(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/followRecords/addComment', data)
}
/**
 *删除评论
 */
export function followRecordsDelComment(id: any) {
  return request.delete<AxiosResult, AxiosResult>(`/lbu/api/followRecords/deleteComment/${id}`)
}
